export const GET_DIALOG_PRODUCTS = 'GET_DIALOG_PRODUCTS';
export const DIALOG_PRODUCTS_RECEIVED = 'DIALOG_PRODUCTS_RECEIVED';

export const SET_DIALOG_PRODUCTS_FILTER = 'SET_DIALOG_PRODUCTS_FILTER';

export const SET_SELECTED_DIALOG_CATEGORY_ID = 'SET_SELECTED_DIALOG_CATEGORY_ID';
export const SET_DIALOG_PRODUCT_SHOW_MODAL = 'SET_DIALOG_PRODUCT_SHOW_MODAL';
